import {
    getGlobalConfig,
    isLoginIn,
    hasProOrg,
    orgId
} from "../../lib/global-config"
import * as qs from "./qs"
import { getPrimarySceneFromUrlPath, getPrimarySceneFromUtm } from "./primary-scene"

const getVersion = (type: "basic" | "pro") => {
    switch (type) {
        case "basic":
            return "0"
        case "pro":
            return "1"
        // case 'free':
        //   return 2
    }
}

export const createOrgCreatorURL = (
    type: "basic" | "pro",
    source: string,
    qs: object = {}
) => {
    // source 用于内站 organization creator 的打点上报
    const version = getVersion(type)
    const config = getGlobalConfig().configUrl

    const accountHost = config["ACCOUNT_HOST"]
    const webHost = config["WEB_HOST"]

    const querystring = Object.keys(qs).reduce((pre, curr, index) => {
        const prefix = index === 0 ? "" : "&"
        const key = curr
        const val = qs[key]
        return `${pre}${prefix}${key}=${val}`
    }, "")

    const targetPath = isLoginIn ? "login" : "signup"

    const base = `${webHost}/organization-creator/${version}/${source}?${querystring}`
    return `${accountHost}/${targetPath}?next_url=${encodeURIComponent(base)}`
}

interface TrialUrlOption {
    isAgile?: boolean
    query?: Record<string, string>
}

export function getTrialUrl(option: TrialUrlOption = {}) {
    const urls = getGlobalConfig().configUrl
    if (!urls) {
        return
    }
    const { isAgile, query = {} } = option
    const webUrl = urls["WEB_HOST"] + "/projects"
    const accountHost = urls["ACCOUNT_HOST"]
    let orgCreatorUrl = createOrgCreatorURL("pro", "Agile", {
        "create-from": "agile-template",
        utm_term: "dev",
        ...query,
    })

    const primaryScene = getPrimarySceneFromUrlPath() || getPrimarySceneFromUtm()
    if (primaryScene) {
        query.primaryScene = primaryScene
    }

    const queryString = qs.stringify(query)

    orgCreatorUrl = queryString ? `${orgCreatorUrl}&${queryString}` : orgCreatorUrl
    if (isLoginIn) {
        if (isAgile) {
            return hasProOrg
                ? urls["WEB_HOST"] +
                "/organization/" +
                orgId +
                "?create-from=agile-template&utm_term=dev" +
                (queryString ? `&${queryString}` : "")
                : orgCreatorUrl
        }
        return webUrl + "?utm_term=dev" + (queryString ? `&${queryString}` : "")
    }

    return (isAgile && isLoginIn) // 注册流程默认选择企业专业版
        ? orgCreatorUrl
        : `${accountHost}/signup?utm_term=dev&next_url=` +
        encodeURIComponent(webUrl + (queryString ? `?${queryString}` : ""))
}

export function getRegisterUrl(from: string) {
    const query: any = {
        utm_content: from
    }

    const primaryScene = getPrimarySceneFromUrlPath() || getPrimarySceneFromUtm()
    if (primaryScene) {
        const urls = getGlobalConfig().configUrl
        const nextUrl = urls["WEB_HOST"] + "/projects?primaryScene=" + primaryScene
        query.next_url = nextUrl
    }
    const queryString = qs.stringify(query)

    return `${
        getGlobalConfig().configUrl["ACCOUNT_HOST"]
        }/signup?${queryString}`
}


export const formLink = (query: string) => `https://form.teambition.net/f/xtqUHj?x_field_1=${query}`
